function ErrorItem(container) {
	this.container = container;
	this.clear = function() {
		this.hasError = false;
		this.msg = '';
	}
	this.clear();
	this.setError = function(msg) {
		this.msg = msg;
		this.hasError = true;
		this.container.count++;
	}
}

function ErrorsContainer() {
	this.count = 0;
	
	this.addPropsFromModelObj = function(modelObj) {
		var keys = Object.keys(modelObj);
		for (var i=0; i < keys.length; i++) {
			this[keys[i]] = new ErrorItem(this);
		}
		return this;
	}
	this.addErrorItem = function(key, item) {
		if (item === undefined) {
			this[key] = new ErrorItem(this);
		} 
		else {
			this[key] = item;
		}
	}
	this.clearAll = function() {
		var keys = Object.keys(this);
		for (var i=0; i < keys.length; i++) {
			if (this[keys[i]].clear) {
				this[keys[i]].clear();
			}
		}
		this.count = 0;
		return this;
	}
}

function BuyerInfo() {
	this.firstName = '';
	this.lastName = '';
	this.email = '';
	this.mobile = '';
	this.dateOfBirth = '';
	this.addressLine1 = '';
	this.cityTown = '';
	this.stateProv = '';
	this.postalCode = '';
}

function CreditCardInfo() {
	this.nameOnCard = '';
	this.cardNumber = '';
	this.expiry = '';
	this.cvv = '';
	this.street = '';
	this.addressNumber = '';
	this.townCity = '';
	this.postalZipCode = '';
	this.unit = '';
}

function wait(ms) {
	return (x) => {
		return new Promise(resolve => setTimeout(() => resolve(x), ms));
	};
}

export { ErrorItem, ErrorsContainer, BuyerInfo, CreditCardInfo, wait }
